module.exports = __webpack_public_path__ + "img/kod_adresata.b94a0680.jpg";